import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import HlsPlayer from '../components/HlsPlayer';
import EventTicker from '../components/EventTicker';
import { listCameras, type Camera as CameraType } from '../lib/api';

export default function Camera() {
  const { id } = useParams<{ id: string }>();
  const [camera, setCamera] = useState<CameraType | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    listCameras()
      .then((cams) => {
        const found = cams.find((c) => c.id === id);
        if (!found) setErr(`camera "${id}" not found`);
        else setCamera(found);
      })
      .catch((e) => setErr(String(e)));
  }, [id]);

  return (
    <main style={{
      maxWidth: 1440,
      margin: '0 auto',
      padding: 'clamp(1rem, 3vw, 2.5rem)',
    }}>
      <Link to="/" className="mono eyebrow" style={{ display: 'inline-block', marginBottom: '1.5rem' }}>
        ← back to grid
      </Link>

      {err && (
        <div className="mono" style={{ color: 'var(--orange)', padding: '1rem', fontSize: 12 }}>
          ▸ {err}
        </div>
      )}

      {camera && (
        <>
          <header style={{ marginBottom: '1.5rem' }}>
            <div className="eyebrow" style={{ marginBottom: 8 }}>
              <span className="dot dot-pulse" style={{ background: camera.status === 'live' ? 'var(--orange)' : 'var(--muted)' }} />
              {camera.id} · {camera.status}
            </div>
            <h1 className="headline" style={{ fontSize: 'clamp(24px, 3vw, 36px)' }}>
              {camera.name}
            </h1>
            <div className="mono" style={{ fontSize: 12, color: 'var(--muted)', marginTop: 4 }}>
              {camera.location}
            </div>
          </header>

          <div className="bracketed" style={{ background: '#000', aspectRatio: '16 / 9', marginBottom: '2rem' }}>
            {camera.status === 'live' ? (
              <HlsPlayer src={camera.hls_url} controls />
            ) : (
              <div className="mono" style={{
                display: 'grid', placeItems: 'center', height: '100%', color: 'var(--muted)',
              }}>
                ▸ {camera.status.toUpperCase()}
              </div>
            )}
          </div>

          <EventTicker />
        </>
      )}
    </main>
  );
}
